(function () {
  function initPromoKiosk(root) {
    if (!root || root.getAttribute("data-promo-kiosk-ready") === "true") return;
    root.setAttribute("data-promo-kiosk-ready", "true");

    var hero = root.querySelector("[data-kiosk-hero]");
    if (!hero) return;

    var reduced = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    var clone = hero.cloneNode(true);
    clone.removeAttribute("id");
    clone.setAttribute("data-kiosk-hero-clone", "true");
    clone.setAttribute("aria-hidden", "true");
    clone.querySelectorAll("[id]").forEach(function (element) {
      element.removeAttribute("id");
    });
    clone.querySelectorAll("a, button, input, select, textarea, [tabindex]").forEach(function (element) {
      element.setAttribute("tabindex", "-1");
    });
    root.appendChild(clone);

    // Chrome on Android keeps its own address bar / tabs on screen unless the
    // page explicitly requests native fullscreen. That API only works from a
    // real user gesture, so the first tap on the kiosk requests it; a small
    // hint shows until that happens (or reappears if fullscreen is exited).
    var canFullscreen = !!(
      root.requestFullscreen ||
      root.webkitRequestFullscreen ||
      root.msRequestFullscreen
    );

    function isFullscreen() {
      return !!(
        document.fullscreenElement ||
        document.webkitFullscreenElement ||
        document.msFullscreenElement
      );
    }

    function requestFullscreen() {
      try {
        if (root.requestFullscreen) {
          var result = root.requestFullscreen();
          if (result && typeof result.catch === "function") result.catch(function () {});
        } else if (root.webkitRequestFullscreen) {
          root.webkitRequestFullscreen();
        } else if (root.msRequestFullscreen) {
          root.msRequestFullscreen();
        }
      } catch (e) {}
    }

    var fullscreenHint = null;

    function refreshFullscreenHint() {
      if (!fullscreenHint) return;
      if (isFullscreen()) {
        fullscreenHint.setAttribute("hidden", "hidden");
      } else {
        fullscreenHint.removeAttribute("hidden");
      }
    }

    if (canFullscreen) {
      fullscreenHint = document.createElement("div");
      fullscreenHint.className = "alive-promo-kiosk__fullscreen-hint";
      fullscreenHint.setAttribute("aria-hidden", "true");
      fullscreenHint.textContent = "Tap to view full screen";
      root.appendChild(fullscreenHint);
      refreshFullscreenHint();

      root.addEventListener("click", function (event) {
        if (isFullscreen() || event.target.closest("a")) return;
        requestFullscreen();
      });

      ["fullscreenchange", "webkitfullscreenchange", "MSFullscreenChange"].forEach(function (eventName) {
        document.addEventListener(eventName, refreshFullscreenHint);
      });
    }

    var idleTimer = null;
    var resetting = false;

    function resetIdleTimer() {
      window.clearTimeout(idleTimer);
      idleTimer = window.setTimeout(function () {
        root.scrollTo({ top: 0, left: 0, behavior: reduced ? "auto" : "smooth" });
      }, 45000);
    }

    function resetLoop() {
      if (resetting || root.scrollTop < clone.offsetTop - 2) return;
      resetting = true;
      window.requestAnimationFrame(function () {
        root.scrollTo({ top: 0, left: 0, behavior: "auto" });
        resetting = false;
      });
    }

    ["pointerdown", "touchstart", "wheel", "keydown", "focusin"].forEach(function (eventName) {
      root.addEventListener(eventName, resetIdleTimer, { passive: eventName !== "keydown" });
    });
    root.addEventListener("scroll", resetLoop, { passive: true });

    var products = root.querySelectorAll("[data-kiosk-product]");
    if (window.IntersectionObserver) {
      var observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          entry.target.toggleAttribute("data-kiosk-active", entry.isIntersecting && entry.intersectionRatio > 0.5);
        });
      }, { root: root, threshold: [0.5] });
      products.forEach(function (product) { observer.observe(product); });
    }

    resetIdleTimer();
    resetLoop();
  }

  function boot() {
    document.querySelectorAll("[data-promo-kiosk]").forEach(initPromoKiosk);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", boot);
  } else {
    boot();
  }
  document.addEventListener("shopify:section:load", boot);
})();
